import React from 'react';
import './Scroll.scss'

const Scroll = () => {
    return (
        <p className='scroll'>
            Scroll
        </p>
    );
};

export default Scroll;